import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'

export default function TdpAssignedModal({
  tdpAssigned,
  setTdpAssigned
}: {
  tdpAssigned: string[]
  setTdpAssigned: React.Dispatch<React.SetStateAction<string[]>>
}) {
  return (
    <Modal open={true}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95vw', sm: '90vw', md: '85vw', lg: '80vw' },
          maxWidth: '1400px',
          height: { xs: '90vh', sm: '85vh', md: '80vh' },
          maxHeight: '900px',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 3,
            py: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'grey.50'
          }}
        >
          <Typography variant='h5' sx={{ fontWeight: 600 }}>
            Assigned TDP List
          </Typography>
          <IconButton
            onClick={() => setTdpAssigned([])}
            size='small'
            sx={{
              '&:hover': {
                backgroundColor: 'error.light',
                color: 'error.contrastText'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
          {Array.isArray(tdpAssigned) && tdpAssigned.length > 0 ? (
            <TableContainer
              component={Paper}
              variant='outlined'
              sx={{ maxHeight: 360 }}
            >
              <Table size='small' stickyHeader aria-label='TDP assignments'>
                <TableHead>
                  <TableRow>
                    <TableCell width={64}>#</TableCell>
                    <TableCell>TDP Names</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tdpAssigned.map((name, idx) => (
                    <TableRow key={`${name}-${idx}`} hover>
                      <TableCell>{idx + 1}</TableCell>
                      <TableCell
                        sx={{
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden'
                        }}
                      >
                        {name}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant='body2' color='text.secondary'>
              No TDPs assigned
            </Typography>
          )}
        </Box>
      </Box>
    </Modal>
  )
}
